import { SalesforceService } from '@weave/schema-gen-ts/dist/schemas/salesforce/v1/salesforce.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaSalesforceV1Service = bindHTTP(SalesforceService);
export const serviceName = 'salesforce-v1' as const;
